<div class="fc-input-prefix-text" *ngIf="getPrefixText().length > 0" [innerHtml]="getPrefixText()"></div>
<div class="fc-input-group">
    <div class="fc-input-group-prepend" *ngIf="prefix" [innerHtml]="prefix"></div>
    <input type="text" class="fc-form-control" [ngModel]="formattedValue" (keyup)="onKeyChange($event)"/>
    <div class="fc-input-group-append" *ngIf="suffix" [innerHtml]="suffix"></div>
</div>
<input type="range" [min]="min" [max]="max" [step]="step" [ngModel]="value" (ngModelChange)="onChange($event)" >